<template>
  <section>
    <RightAmerican v-if="getGameConsole === 'american'"/>
    <RightTerminal v-if="getGameConsole === 'terminal'"/>
    <RightClassic v-else/>
  </section>
</template>

<script>
  import { mapGetters } from "vuex";
  import { isMobileOnly } from "mobile-device-detect";
  import RightClassic from "@/components/RightClassic.vue";
  import RightAmerican from "@/components/american/RightAmerican.vue";
  import RightTerminal from "@/components/terminal/RightTerminal.vue";




  export default {
    name: 'Right',
    components: {
      RightClassic,
      RightAmerican,
      RightTerminal
    },
    data: () => ({
      isMobileOnly: isMobileOnly,
    }),
    computed: {
      ...mapGetters({
        'getGameConsole': 'settings/getGameConsole'
      }),

    },
    methods: {

    }
  };
</script>
